// Case-insensitive: variables are created in lower case
export const findVariable = (knownVariables, name) => knownVariables.find(variable => variable.name.toLowerCase() === String(name).toLowerCase());

export const resolveOrCreateVariable = async (name, type, knownVariables, addVariable) => {
    const existing = findVariable(knownVariables, name);
    if (existing) return existing;

    const created = await addVariable({ name: String(name).toLowerCase(), type });
    if (!created) throw new Error('could not create the variable "' + name + '"');
    knownVariables.push(created);
    return created;
};
